import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription, fromEvent } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';
import { environment } from '@environment/environment';
@Component({
    selector: 'core-helpers-sso-providers',
    templateUrl: './sso-providers.component.html',
    styleUrls: ['./sso-providers.component.scss']
})
export class CoreHelpersSsoProvidersComponent implements OnInit, OnDestroy {
    
    protected readonly SSO_LOGIN_URL_PREFIX = '/web/login/sso/oauth2/';

    @Output() ssoLogin = new EventEmitter<string>();

    public error:boolean;
    public loading:boolean = true;
    public waiting: boolean = false;
    private popupUrl:string = "";

    protected ssoCompleted: boolean = false;
    protected popup: any;
    protected provider: string;

    private messageSubscription: Subscription;

    // @HostListener('window:message', ['$event'])
    // onWindowMessage(event) {
    //     console.log("event DATA--->", event.data);  
    //     if(event.data.hasOwnProperty('completed') && event.data.completed == true){
    //         this.login();
    //         this.popup.close();
    //     }
    //     // TODO manage when completed == false (error)
    // }

    constructor( public httpClient: HttpClient, 
        private urlSrv: UrlService) {}

    ngOnInit() {
        this.loading = false;
        // this will replace @Hostlistener which is "not unsubscribable"
        const messageObservable = fromEvent<MessageEvent>(window, 'message');
        this.messageSubscription = messageObservable.subscribe((event: MessageEvent) => {
            console.debug('Received message event: ', event);
            // Handle the message
            if(event.data.hasOwnProperty('completed') && event.data.completed == true){
                this.login();
                this.popup.close();
            }
            // TODO manage when completed == false (error)
        });
    }

    ngOnDestroy(): void {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
        }
      }

    onSoo(service: string){
        this.popupUrl = environment.twonaBaseUrl + this.SSO_LOGIN_URL_PREFIX +service; //'web/login/sso/oauth2/{service_name}'
        this.provider = service;
        console.debug(" Popup url: "+this.popupUrl,this.provider);
        this.openPopup(this.popupUrl);
        
        
    }

    protected openPopup(url: string) {
        // Open the popup window and pass the main window object as the second argument
        this.popup = window.open(url, 'PopupWindow', 'width=700,height=700,resizable=yes,dependent=yes');
                
        // Make the popup opener window dependent on this main window (not the component!!!)
        this.popup.opener = window;
       
    }

    public login(){
        this.ssoLogin.emit(this.provider)
        // We manage login responses in the parent component through the output event
       
    }

}
